const { formatMoney } = window.BAO.Utils

/** @typedef {string|null} OptionValue */

class StackSetProduct extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['checkbox', 'id-input', 'data']
  }

  setupListeners () {
    super.setupListeners()

    if (this.els['option-selector']) {
      this.els['option-selector'].elements.forEach(selector => {
        this.listeners.add(selector, 'change', () =>
          this.updateSelectedVariant(),
        )
      })
    }
  }

  updateSelectedVariant () {
    const selectors = this.els['option-selector'].elements

    const selectedVariant = this.getVariantFromOptions(
      selectors.map(selector => selector.value),
    )

    this.variantId = selectedVariant.id
  }

  /** @param {[OptionValue, OptionValue, OptionValue]} options */
  getVariantFromOptions (options) {
    return this.data.find(variant => {
      return variant.options.every((option, index) => options[index] === option)
    })
  }

  get data () {
    return JSON.parse(this.els.data.element.textContent)
  }

  get checked () {
    return this.els.checkbox.element.checked
  }

  get variantId () {
    return Number(this.els['id-input'].element.value)
  }

  /** @param {number|string} id */
  set variantId (id) {
    const variant = this.data.find(variant => variant.id === Number(id))

    if (!variant) {
      return
    }

    const {
      'id-input': idInput,
      'compare-price': comparePrice,
      price,
    } = this.els

    idInput.element.value = id

    if (comparePrice) {
      const variantIsOnSale =
        variant.compare_at_price && variant.price < variant.compare_at_price

      comparePrice.element.toggleAttribute('hidden', !variantIsOnSale)
      comparePrice.element.textContent = formatMoney(variant.compare_at_price)
    }

    if (price) {
      price.element.textContent = formatMoney(variant.price)
    }
  }

  get variant () {
    return this.data.find(variant => variant.id === this.variantId)
  }

  get value () {
    if (!this.checked) {
      return null
    }

    return this.variantId
  }
}

if (!customElements.get('stack-set-product')) {
  customElements.define('stack-set-product', StackSetProduct, {
    extends: 'article',
  })
}
